import { DepositSubmitted } from '../../../../investment/components/transfer/DepositSubmitted';

export default function DepositSubmittedScreen() {
    return <DepositSubmitted />;
}
